import Constants from 'expo-constants';

const toOptionalString = (value: unknown) =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

const normalizeOrigin = (rawOrigin?: string | null) => {
  if (!rawOrigin) return undefined;
  if (rawOrigin.startsWith('exp://')) {
    return rawOrigin.replace('exp://', 'http://');
  }
  if (rawOrigin.startsWith('ws://')) {
    return rawOrigin.replace('ws://', 'http://');
  }
  if (rawOrigin.startsWith('wss://')) {
    return rawOrigin.replace('wss://', 'https://');
  }
  if (rawOrigin.includes('://')) {
    return rawOrigin;
  }
  return `http://${rawOrigin}`;
};

const resolveDevOrigin = () => {
  const expoConfigHost = toOptionalString(
    (Constants.expoConfig as unknown as Record<string, unknown> | undefined)?.['hostUri'],
  );
  const expoGoConfig = Constants.expoGoConfig as Record<string, unknown> | undefined;
  const expoGoHost = toOptionalString(expoGoConfig?.['hostUri']);
  const expoGoDebuggerHost = toOptionalString(expoGoConfig?.['debuggerHost']);

  const candidates = [
    toOptionalString(Constants.experienceUrl),
    expoConfigHost,
    expoGoHost,
    expoGoDebuggerHost,
  ];

  for (const candidate of candidates) {
    const normalized = normalizeOrigin(candidate);
    if (normalized) {
      return normalized;
    }
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return 'http://localhost:8081';
};

const buildPath = (relativePath: string) =>
  relativePath.startsWith('/') ? relativePath : `/${relativePath}`;

export const generateAPIUrl = (relativePath: string) => {
  const path = buildPath(relativePath);

  // If EXPO_PUBLIC_API_BASE_URL is set, always use it (even in development builds)
  // This allows development builds to use production APIs while still using Metro for hot reload
  const apiBase = normalizeOrigin(process.env.EXPO_PUBLIC_API_BASE_URL);
  if (apiBase) {
    return apiBase.concat(path);
  }

  // Fallback to local development URL if no API base URL is set
  if (process.env.NODE_ENV === 'development') {
    return resolveDevOrigin().concat(path);
  }

  console.warn(
    '[generateAPIUrl] EXPO_PUBLIC_API_BASE_URL is not defined. Falling back to local development URL. ' +
    'This may cause API calls to fail in production builds.'
  );
  return resolveDevOrigin().concat(path);
};
